import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clickWidget } from '../../actions';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class IconLinks extends Component {

  render() {
    const { client, clickWidget } = this.props
    const ListItemStyle = { 'line-height': '0px', 'font-size': '14px', width: '200px'}

    const loc = cookies.get('locale')

    if(client.x['i'] === undefined) {
      return (null)
    }

    return(
      <div>
        <div className='UserRanking'
          style={{
            transform: `translate3d(
          ${client.x['i']}px,
          ${client.y['i']}px, 0px)`}}>

          <div onMouseDown={e => clickWidget(e, 'i') }
            style={{cursor: 'pointer'}}>
            <MuiThemeProvider>
              <List>
                <Subheader>{locale.languages(loc)}</Subheader>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <a href={`/nodes/${locale.java_link(loc)}`}> </a>}>
                    <i className="fas fa-coffee fa-lg r-icon" /><div className='user'>　Java</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <a href={`/nodes/${locale.php_link(loc)}`}> </a>}>
                    <i className="fab fa-php fa-lg r-icon" /><div className='user'>　PHP</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <a href={`/nodes/${locale.cpp_link(loc)}`}> </a>}>
                    <i className="far fa-copyright fa-lg r-icon" /><div className='user'>　C++</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <a href={`/nodes/${locale.swift_link(loc)}`}> </a>}>
                    <i className="fab fa-earlybirds fa-lg r-icon" /><div className='user'>　Swift</div>
                </ListItem>
                <Divider />
                <ListItem style={ListItemStyle} containerElement={
                    <a href={`/nodes/${locale.scala_link(loc)}`}> </a>}>
                    <i className="fas fa-signal fa-lg r-icon" /><div className='user'>　Scala</div>
                </ListItem>
              </List>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
});

const mapDispatchToProps = {
  clickWidget
}

export default connect(mapStateToProps, mapDispatchToProps)(IconLinks)



// WEBPACK FOOTER //
// ./src/components/ranking/Iconlinks.js